import { render, staticRenderFns } from "./AIRecord.vue?vue&type=template&id=19f02594&scoped=true"
import script from "./AIRecord.vue?vue&type=script&lang=js"
export * from "./AIRecord.vue?vue&type=script&lang=js"
import style0 from "./AIRecord.vue?vue&type=style&index=0&id=19f02594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f02594",
  null
  
)

export default component.exports